export class CustomParamsHoursBackModel {
  hoursBack: number;
}
